export interface ITreeCollapsable {
  collapseTree(): void;
}

export function instanceOfITreeCollapsable(instance: any): instance is ITreeCollapsable {
  if (!instance) { return false; }
  return (instance.collapseTree !== undefined);
}
